<nav class="navbar navbar-expand-lg navbar-dark bg-secondary">
    <a class="navbar-brand" href="#">
        <img style="height: 45px; width: auto;" src="assets/img/osrga.jpeg" alt="">
    </a>
    <button id="colap" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar-nav mr-auto">
            <li id="botonhome" class="nav-item active" routerLinkActive="active">
                <a (click)="collapsear()" routerLink="/home" [routerLinkActive]="['active']" class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
            </li>

            <!--
            <li *ngIf="role=='USER' || role=='MULTI' || role=='ADMIN' || role=='DELEGADO'" class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Mis Gastos
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a routerLink="/vergastos" (click)="collapsear()" class="dropdown-item">Ver mis gastos</a>
                    <div class="dropdown-divider"></div>
                    <a routerLink="/nuevogasto" (click)="collapsear()" class="dropdown-item">+ Nuevo Gasto</a>
                </div>
            </li>
        -->
            <!--AUTORIZANTE O TESORERO -->
            <!--
            <li *ngIf="role=='AUTORIZADOR'" class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Gastos <span *ngIf="noti" class="badge badge-pill badge-danger">{{ noti }}</span>
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a (click)="collapsear()" routerLink="/vergastos-pagos" class="dropdown-item">
                        Gastos Para AUTORIZAR <span *ngIf="noti" class="badge badge-pill badge-danger">{{ noti }}</span>
                    </a>
                    <div class="dropdown-divider"></div>
                    <a (click)="collapsear()" routerLink="/vergastos" class="dropdown-item">Ver Gastos Propios</a>
                    <div class="dropdown-divider"></div>
                    <a (click)="collapsear()" routerLink="/nuevogasto" class="dropdown-item">+ Nuevo Gasto</a>
                </div>
            </li>
        -->
            <!-- jorge -->
            <li hidden class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    OCR-SCAN
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a (click)="collapsear()" routerLink="/cgimage" class="dropdown-item">
                        SCAN Documents
                    </a>
                    <div class="dropdown-divider"></div>
                </div>
            </li>
            <li *ngIf="role ==='ADMIN' || role === 'DATAENTRY' || role === 'INFO'" class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Novedades O/S
                    <span *ngIf="cantidad != 0" class="badge badge-pill badge-info">{{ cantidad }}</span>
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a (click)="collapsear()" routerLink="/cargar" class="dropdown-item">
                        <i class="fas fa-hand-holding-usd"></i> Gestionar Novedades
                    </a>
                    <div class="dropdown-divider"></div>
                    <a  *ngIf="cantidad != 0" data-toggle="modal" data-target="#MODALNOTI" ><span (click)="getNotiDet()" class="badge badge-pill badge-info">Ver {{ cantidad }} Comentarios</span> </a>
                </div>
            </li>
            <li *ngIf="role ==='ADMIN' || role === 'DATAENTRY'" class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-cogs"></i> Gestión
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a (click)="collapsear()" routerLink="/empresas" class="dropdown-item">
                        <i class="fas fa-building"></i> Empresas
                    </a>
                </div>
            </li>

            <li *ngIf="role =='ADMIN' || role == 'REPORTER'" class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-file-import"></i> IMPORTADORES
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a *ngIf="role === 'ADMIN' || role === 'REPORTER'" (click)="collapsear()" routerLink="/impo-nominas" class="dropdown-item">
                        <i class="far fa-file-alt"></i> IMPORTADOR NOMINAS
                    </a>
                    <a *ngIf="role === 'ADMIN' || role === 'REPORTER'" (click)="collapsear()" routerLink="/impo-transferencias" class="dropdown-item">
                        <i class="far fa-file-alt"></i> IMPORTADOR TRANSFERENCIAS
                    </a>
                </div>
            </li>

            <li *ngIf="role =='ADMIN' || role == 'REPORTER'" class="nav-item dropdown" routerLinkActive="active">
                <a id="botonhome" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-chart-bar"></i> REPORTES
                </a>
                <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                    <a (click)="collapsear()" routerLink="/sinomyt" class="dropdown-item">
                        <i class="fas fa-database"></i> REPORTE DE EMPRESAS
                    </a>
                    <a (click)="collapsear()" routerLink="/reporte-deudas" class="dropdown-item">
                        <i class="fas fa-file-invoice-dollar"></i> REPORTE DE DEUDAS
                    </a>
                    <a (click)="collapsear()" routerLink="/reporte-beneficiarios" class="dropdown-item">
                        <i class="fas fa-users"></i> REPORTE DE BENEFICIARIOS
                    </a>
                    <a (click)="collapsear()" routerLink="/liquidaciones" class="dropdown-item">
                        <i class="fas fa-calculator"></i> LIQUIDACIONES
                    </a>
                    <a (click)="collapsear()" routerLink="/liquidaciones-guardadas" class="dropdown-item">
                        <i class="fas fa-archive"></i> LIQUIDACIONES GUARDADAS
                    </a>
                </div>
            </li>

            <li *ngIf="!fs" style="cursor: pointer;" id="fs" class="nav-item active" routerLinkActive="active">
                <a (click)="openFullscreen()" class="nav-link"><i class="fas fa-expand"></i> </a>
            </li>
            <li *ngIf="fs" style="cursor: pointer;" id="fs2" class="nav-item active" routerLinkActive="active">
                <a (click)="closeFullscreen()" class="nav-link"> <i class="fas fa-compress-arrows-alt"></i> </a>
            </li>
        </ul>



        <ul *ngIf="usuario" class="nav-item dropdown">
            <a id="nameuser" href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-user-check"></i> Usuario: "{{ usuario }}"
            </a>
            <div class="dropdown-menu animated fadeIn fast" aria-labelledby="navbarDropdown">
                <a class="dropdown-item">ID: {{ usuario }} </a>
                <!--<a class="dropdown-item">DEL-SEC: {{ seccional }} </a>-->
                <a class="dropdown-item">SECDEL: {{ secdet }} </a>
                <a class="dropdown-item">ROL DE USUARIO: {{ role }}</a>
                <div class="dropdown-divider"></div>
                <a routerLink="/changepass" (click)="collapsear()" class="dropdown-item">CAMBIAR CONTRASEÑA</a>
                <div class="dropdown-divider"></div>
                <a routerLink="/configuracion" (click)="collapsear()" class="dropdown-item"><i class="fas fa-cog"></i> CONFIGURACIÓN</a>
                <div class="dropdown-divider"></div>                
                    <span>
                        <input *ngIf="usuario=='matiasmasciotta'" type="text" [(ngModel)]="iduser" name="iduser">
                        <button  *ngIf="usuario=='matiasmasciotta'" href="#" style="cursor: pointer;" (click)="cambiaUser()"> CHANGE USER </button>
                    </span>
                <div class="dropdown-divider"></div>
                <a *ngIf="usuario=='matiasmasciotta'" href="#" style="cursor: pointer;" (click)="cambiaRol('ADMIN')" class="dropdown-item">cambiar a: ADMIN</a>
                <a *ngIf="usuario=='matiasmasciotta'" href="#" style="cursor: pointer;" (click)="cambiaRol('DATAENTRY')" class="dropdown-item">cambiar a: DATAENTRY</a>
                <a *ngIf="usuario=='matiasmasciotta'" href="#" style="cursor: pointer;" (click)="cambiaRol('REPORTER')" class="dropdown-item">cambiar a: REPORTER</a>
                <div class="dropdown-divider"></div>
            </div>
        </ul>

        <form class="form-inline my-2 my-lg-0">
            <div class="nav-item" routerLinkActive="active">
                <!--
                <button *ngIf="!auth.isAuthenticated()" routerLink="/login" class="btn-dark">Iniciar Sesion</button>
                -->
                <button *ngIf="!usuario" routerLink="/login" class="btn-dark" (click)="collapsear()"> <i class="fas fa-user-circle"></i> Iniciar Sesion</button>
            </div>
            <div class="nav-item" routerLinkActive="active">
                <!--
                <button *ngIf="auth.isAuthenticated()" (click)="salir()" class="btn-danger">Cerrar Sesion</button>
                -->
                <button *ngIf="usuario" routerLink="/home" (click)="borrarLocal()" class="btn-danger">Cerrar Sesion</button>
            </div>
        </form>
    </div>
</nav>


<!-- Modal notifi -->
<div style="margin-top: 100px" class="modal fade" id="MODALNOTI" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog bg-primary" role="document">
        <div id="modito" class="modal-content bg-primary">
            <div class="modal-header" style="text-align: center;">
                <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">Lista de comentarios</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>       
            <div class="modal-body">
                <table style="width: 100%" class="table table-primary table-responsive-xl">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>RAZON</th>
                            <th>COMENTARIO</th>
                            <th>ATENDIDO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <app-loading class="m-5" *ngIf="loadingnotidet"></app-loading>
                        <tr class="bg-light" *ngFor="let noti of notificaciones">
                            <td>
                                {{noti.id}}
                            </td>
                            <td>
                                {{noti.razon}}
                            </td>
                            <td>
                                {{noti.comentario | uppercase}}
                            </td>
                            <td style="text-align: right">
                                {{noti.atendido | uppercase}}
                                <button (click)="onClick( noti.id )" class="btn-info" *ngIf="noti.atendido === 'NO'">
                                    <mat-icon aria-label="ATENDER">
                                        done
                                    </mat-icon>
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="notificaciones.length === 0" style="text-align: center;"><td></td><td></td><td style="text-align: center;"><u> TODO AL DÍA!!</u></td><td></td></tr>
                    </tbody>
            </table>
            </div>  
        </div>
        </div>
    </div>